module.exports = __webpack_public_path__ + "static/media/Assets-05-MNM-01.eeb1be91.png";